import Image from 'next/image';

const MASK = 'linear-gradient(to bottom, transparent 0, #000 45rem)';

export function LeaderboardBackground() {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-x-0 bottom-0 top-[-20rem] overflow-hidden"
      style={{ WebkitMaskImage: MASK, maskImage: MASK }}
    >
      <div
        className="absolute left-1/2 -translate-x-1/2 top-[48.25rem] h-[73rem] blur-[26rem] max-lg:top-[58.1rem] max-lg:h-[73.6rem] max-lg:w-[179.75rem] lg:left-[4.5rem] lg:-right-[5rem] lg:translate-x-0 lg:!bg-[linear-gradient(180deg,#0c1e29_13.04%,#314c5e_120.36%)]"
        style={{
          backgroundImage:
            'linear-gradient(180deg, #0f2532 13%, #3d5e74 120%), linear-gradient(180deg, #274558 36%, #3d5e74 108%)',
        }}
      />

      <Image
        src="/leaderboard/world-map.svg"
        alt=""
        aria-hidden
        width={1334}
        height={654}
        unoptimized
        className="absolute left-1/2 top-[41.25rem] h-auto w-[160%] max-w-none -translate-x-1/2 opacity-[0.65] max-lg:top-[60.6rem] max-lg:w-[131.75rem] lg:w-[167.5rem]"
      />

      <div className="absolute inset-x-0 bottom-0 top-[131.375rem] flex flex-col max-lg:top-[91.5rem]">
        <div className="h-[41.25rem] w-full bg-gradient-to-b from-transparent to-black" />
        <div className="w-full flex-1 bg-black" />
      </div>
    </div>
  );
}
